// @flow

import type {TransformOrigin, BoxPosition} from './typedef';

type GetTransformOriginValue = (transformOrigin: TransformOrigin | BoxPosition) => string;

/**
* Get transform origin value.
* @namespace
* @property {object} param - The default values for configuration parameter.
* @property {string | number} param.horizontal - Origin value horizontal.
* @property {string | number} param.vertical - Origin value vertical.
* @returns {string}
 @deprecated It will be removed in 6 months 04-28-2026. Use Floating instead.
*/
export const getTransformOriginValue: GetTransformOriginValue = ({horizontal, vertical}) => (
    [horizontal, vertical].map(n => (typeof n === 'number' ? `${n}px` : n.toLowerCase())).join(' ')
);

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
